/** No access token, health intake or payment record is persisted here. */
export class SessionScope {
  constructor(deployment, origin) { this.deployment = deployment; this.origin = origin; this.epoch = 0; this.actor = null; this.scope = null; }
  enter(actor) {
    if (!actor || typeof actor.id !== 'string' || actor.role !== 'member' || !actor.verified) throw new Error('Doğrulanmış üye gerekiyor.');
    this.epoch += 1; this.actor = Object.freeze({ id: actor.id, name: actor.name || '', role: actor.role, verified: true });
    this.scope = JSON.stringify([this.deployment, this.origin, actor.id]); return this.capture();
  }
  capture() { if (!this.scope) throw new Error('Oturum yok.'); return Object.freeze({ scope: this.scope, epoch: this.epoch }); }
  valid(ticket) { return Boolean(ticket && ticket.scope === this.scope && ticket.epoch === this.epoch && this.actor); }
  leave() { const old = this.scope; this.epoch += 1; this.actor = null; this.scope = null; return old; }
}
